import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'olb-app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['loading.component.scss'],
    imports: []
})
export class LoadingComponent implements OnInit {
  isIE: boolean;
  isIEVersion9OrBelow: boolean;

  ngOnInit() {
    this.isIE = /msie\s|trident\//i.test(window.navigator.userAgent);
    this.isIEVersion9OrBelow =
      /MSIE\s/.test(navigator.userAgent) &&
      parseFloat(navigator.appVersion.split('MSIE')[1]) < 10;
  }
}
